import { FeatureToggleState } from './constants';
import { PaymentMode } from './settings.model';

export interface ServiceFeeBasePoint {
  name: string;
  value: string;
}

export interface FeatureToggleOption {
  name: string;
  value: FeatureToggleState;
}

export enum ValidationStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  LOADING = 'LOADING'
}

export enum PaymentSubCategoryTypes {
  INSTALLMENT = 'INSTALLMENT'
}

export interface SubCategory {
  displayName: string;
  type: PaymentSubCategoryTypes;
  paymentModes: PaymentMode[];
}

export enum PaymentCategoryTypes {
  SELF_CHECKOUT = 'SELF_CHECKOUT',
  ASSISTED_CHECKOUT = 'ASSISTED_CHECKOUT',
  MANUAL = 'MANUAL'
}

export interface PaymentCategory {
  displayName: string;
  type: PaymentCategoryTypes;
  paymentModes: PaymentMode[];
  subCategories?: SubCategory[];
}
